import { Box, Button, Flex, Image, Link, Text, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link as RRLink } from "react-router-dom";
import { registerAPI } from "../../Redux/Auth/auth.action";
import FormInput from "../FormInput";

const initFormState = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const Register = () => {
  const toast = useToast();
  const [formData, setFormData] = useState(initFormState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const navigate = useNavigate();

  const {
    register: { isSuccessfull },
  } = useSelector((state) => state.auth);

  // console.log(isSuccessfull);

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    if (formData.password.length < 6 && formData.password.length > 0) {
      toast({
        title: "Password should be atleast 6 characters",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!formData.email && !formData.password && !formData.name) {
      toast({
        title: "Please enter all the details",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!formData.name) {
      toast({
        title: "Please enter name",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!formData.email) {
      toast({
        title: "Please enter email",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!formData.password) {
      toast({
        title: "Please enter password",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    // check if email id is valid
    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (!emailRegex.test(formData.email)) {
      toast({
        title: "Please enter valid email",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // check if email id is of ripik.in domain or sunpharma.com domain
    const emailDomain = formData.email.split("@")[1];
    if (emailDomain !== "ripik.in" && emailDomain !== "sunpharma.com" && emailDomain !== "ripik.ai") {
      toast({
        title: "Please enter valid domain",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    delete formData.confirmPassword;
    dispatch(registerAPI(formData));
  };

  useEffect(() => {
    if (isSuccessfull) {
      toast({
        title: "Registered Succesfully",
        status: "success",
        duration: "1000",
        isClosable: true,
      });
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessfull]);
  return (
    <Box color="white" w="100%" h="100vh" bgGradient="linear(to-r, blue.100, blue.400)" position="fixed">
      <Flex direction="column" align="center" w="50%" m="auto" mt="20px">
        <Image w="65%" src="https://i.ibb.co/P1DCVSv/ripik-trademark-logo.png" />
        <Box w="80%" opacity="0.9">
          <Flex direction="column" bg="white" alignItems="center" p="20px" borderRadius="20px" boxShadow="dark-lg">
            <Text mt="2rem" fontWeight="700" fontSize="22px" align="center" color="black">
              Welcome to Ripik Optimus
            </Text>
            <FormInput name="name" value={formData.name} handleChange={handleChange} type="text" />
            <FormInput name="email" value={formData.email} handleChange={handleChange} type="email" />
            <FormInput
              name={"password"}
              value={formData.password}
              handleChange={handleChange}
              type="password"
              minLength={6}
            />
            <Button type="submit" w="20%" m="auto" colorScheme="blue" mt="30px" mb="10px" onClick={handleSubmit}>
              Register
            </Button>
            <Link as={RRLink} to="/login" color="black">
              Already Have an account? Click here to login
            </Link>
            <Text fontSize="15px" mt="20px" opacity="0.6" align="center" color="black">
              Powered by Ripik.AI
            </Text>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default Register;
